var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "52px",
    viewBox: "0 0 64 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Maleprofile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-189.000000, -126.000000)",
    stroke: "#043F93",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maleprofile",
    transform: "translate(190.000000, 127.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2375",
    strokeLinecap: "round",
    x: 0,
    y: 0,
    width: 62,
    height: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3088235,16.8905272 L12.3088235,13.2242209 C12.3088235,9.60258371 15.2433054,6.66666667 18.8537318,6.66666667 L34.3214286,6.66666667 L34.3214286,16.9123046 C35.5829042,17.1555698 36.5357143,18.2654122 36.5357143,19.5965838 L36.5357143,20.4034162 C36.5357143,21.7439892 35.567874,22.8591969 34.295619,23.0924179 C33.905427,28.8134838 29.1396243,33.3333333 23.3151261,33.3333333 C17.4988839,33.3333333 12.7363549,28.8269182 12.3360613,23.1133109 C10.9972476,22.935531 9.96428571,21.7894474 9.96428571,20.4034162 L9.96428571,19.5965838 C9.96428571,18.2195596 10.9854742,17.080323 12.3088235,16.8905272 Z",
    id: "Rectangle-2323",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.051023,33.3333333 L15.4621241,38.6363636 L9.29880222,38.6363636 C6.1358765,38.6363636 3.32142857,41.3064629 3.32142857,44.4444444 L3.32142857,49.4444444 M43.1785714,50 L43.1785714,44.3181818 C43.1785714,41.1865854 40.6198091,38.6363636 37.4634158,38.6363636 L30.5386531,38.6363636 L27.9497542,33.3333333",
    id: "Rectangle-2326",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3607858,10 L56.4642857,10",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3607858,14.4444444 L56.4642857,14.4444444",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3607858,18.8888889 L52.0357138,18.8888889",
    id: "Line",
    strokeLinecap: "square"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverLicense);
export default __webpack_public_path__ + "static/media/DriverLicense.022bff7cfd242c0f2a128ca8740fb807.svg";
export { ForwardRef as ReactComponent };